import { Box, Typography } from "@mui/material"
import { ErrorMessage, Formik } from "formik"
import closeIcon from '../../assets/icons/close.svg'
import * as Yup from 'yup'
import { VALIDATION_MESSAGES } from "../../utility/constantValidationMessages"
import { useDispatch, useSelector } from "react-redux"
import PageDropdown from "../page-dropdown/PageDropdown"
import { UI_CONSTANT } from "../../utility/constants"
import { transferBatchOrBranch } from "../../store/builders/enrollment/enrollment.builder"
import apiClient from "../../services/axois"
import { useEffect, useState } from "react"
import { getCourseBranchFees } from "../../store/builders/course/course.builder"
import '../../pages/enrollment/enrollmentList.scss'
import Button from "../button/Button"

export const DrawerList = ({ enrollData,toggleDrawer, setOpen }) => {

    const dispatch = useDispatch()

    const [initialValues, setInitialValues] = useState({
        studentId: enrollData?.studentId,
        branch: enrollData?.branchId,
        batch: enrollData?.batchId,
    })
 
    const [batchOptionList, setBatchOptionList] = useState([]) 
    const [batchFees, setBatchFees] = useState('')
    const branchList = useSelector((store) => store.branch.branchTableData)
    const { branchCourseFees } = useSelector((state) => state?.course)
    const validationSchema = Yup.object().shape({
        branch: Yup.string().required(VALIDATION_MESSAGES.BRANCH_REQUIRED),
        batch: Yup.string().required(VALIDATION_MESSAGES.BATCH_REQUIRED),
      })
    
      const branch = branchList.map((branch) => {
        return { label: branch.branchName, value: branch.branchId }
      })

      useEffect(()=>{
        getBatchOptionList( enrollData?.branchId, enrollData?.courseId )
      },[])
    const handleFormSubmit = (data) => {
        setOpen(false)
        dispatch(transferBatchOrBranch(data))
    } 
    

    const getBatchOptionList = async( branchId, courseId, branchFees) => {
        const url = branchFees ? `/branch/batch/${branchId}/${courseId}?branchFees=${true}` :`/branch/batch/${branchId}/${courseId}`
     
        const response = await apiClient.get(url)
        const batches = response.data.result.Batch.map((batch) => {
          return {
            value: batch.batchId,
            label: batch.batchNo,
          }
      })

      setBatchFees(response?.data?.result?.studentFees)
      setBatchOptionList(batches)
    }

    const handleBranchDropdown = async(e, setFieldValue) => {
        e.preventDefault();
        let branchFees = true
        const branchValue = e.target.value;
        setFieldValue('branch', branchValue);
        getBatchOptionList( branchValue, enrollData?.courseId, branchFees );
      };
    const handleBatchDropdown = async(e, setFieldValue, branchId) => {
        e.preventDefault();
        const batchValue = e.target.value;
      
        setFieldValue('batch', batchValue);
        dispatch(
            getCourseBranchFees({
              courseId: enrollData?.courseId,
              batchId: e.target.value,
              branchId: branchId,
              studentId: enrollData?.studentId
            }),
          )
      };
    return (
      <Box className='timetable-drawer' role='presentation'>
        <Box className='timetable-drawer-header flex justify-between align-center'>
          <Typography className='timetable-drawer-title'>Transfer Batch/Branch</Typography>
          <img className='timetable-drawer-icon' src={closeIcon} alt='Close' onClick={()=>toggleDrawer(false)} />
        </Box>
        <Box className='drawer-horizontal-line' />

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            handleFormSubmit(values)
          }}
        >
          {({ values, handleChange, handleSubmit, setFieldValue }) => (
            <form>
              <div className='timetable-drawer-input-fields'>
                <div className='timetable-drawer-input-pair flex justify-between'>
                  <div className='timetable-drawer-input'>
                    <label className='timetable-drawer-input-label' htmlFor=''>
                      Branch
                      <span className='required-symbol'>*</span>
                    </label>
                    <PageDropdown
                      options={branch}
                      selectedValue={values.branch}
                      className={'timetable-drawer-option'}
                      onChange={(e) => handleBranchDropdown(e, setFieldValue)}
                      name={'branch'}
                      placeholder={'Select branch'}
                    />
                    <ErrorMessage name='branch' component='div' className='error-msg' />
                  </div>

                  <div className='timetable-drawer-input'>
                    <label className='timetable-drawer-input-label' htmlFor=''>
                      Batch
                      <span className='required-symbol'>*</span>
                    </label>
                    <PageDropdown
                      options={batchOptionList || []}
                      selectedValue={values.batch}
                      className={'timetable-drawer-option'}
                      onChange={(e) => handleBatchDropdown(e, setFieldValue, values.branch)}
                      name={'batch'}
                      placeholder={'Select batch'}
                      disabled={!values?.branch}
                    />
                    <ErrorMessage name='batch' component='div' className='error-msg' />
                  </div>
                </div>
              </div>
              <div className='right-drawer-save'>
                <div className='transfer-batch-p'>
                  {/* {branchCourseFees?.onetimeFees && ( */}
                    <p className='transfer-txt'>
                      {`Course fees for selected Branch and Batch is ₹${branchCourseFees?.studentFees}`}
                    </p>
                  {/* )} */}
                  <Button
                    customClassName={'drawer-save-btn'}
                    onClick={handleSubmit}
                    disabled={!branchCourseFees?.studentFees}
                  >
                    {UI_CONSTANT.SAVE}
                  </Button>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </Box>
    )
  }